import PageLayout from '@/components/feature/PageLayout';
import Team from '@/pages/home/components/Team';
import TeamRoles from '@/pages/team/components/TeamRoles';
import TeamValues from '@/pages/team/components/TeamValues';

export default function TeamPage() {
  return (
    <PageLayout>
      <Team />
      <TeamRoles />
      <TeamValues />
    </PageLayout>
  );
}